(function (app, ng) {

    app.config([
        "$stateProvider", function ($stateProvider) {
            $stateProvider.state("Home.Tools.MarketPlace.ElevateLifeAssets.Schechter",
                {
                    url: "/Schechter",
                    component: "e4lschechter",
                    PageTitle: "Elevate for Life - Schechter"
                });
        }
    ]);

    app.component("e4lschechter",
        {
            templateUrl: "App/Tools/MarketPlace/ElevateLifeAssets/Schechter/Schechter.html",
            controller: e4LSchechterCtrl,
            bindings: {
            }
        });

    e4LSchechterCtrl.$inject = ["$timeout", "$state", "$mdDialog", "$filter", "wistiaApi", "permissionService"];

    function e4LSchechterCtrl($timeout, $state, $mdDialog, $filter, wistiaApi, permissionService) {
        var $ctrl = this;
        
        $ctrl.loadResources = function () {

            $ctrl.loadingAssets = true;
            wistiaApi.getElevateForLifeSchechterAssets().then(function (response) {

                var projectMedias = response.medias;
                $ctrl.Assets = [];

                var uniqueMedias = $filter("orderBy")($filter("unique")(projectMedias, "section"), "section");
                ng.forEach(uniqueMedias, function (value, key) {
                    var newAsset =
                    {
                        Title: value.section,
                        Active: uniqueMedias.length > 1 ? true : false,
                        Medias: ($filter("filter")(projectMedias, { section: value.section }))
                    }
                    $ctrl.Assets.push(newAsset);
                });

            }).then($ctrl.loadingAssets = false);
        }

        if (permissionService.hasOnePermission("ElevateForLife:Access")) {
            $ctrl.loadResources();
        }
    }



})(window.app, window.angular); // jshint ignore:line